export default "__VITE_ASSET__Bvzs8fej__"